import { useAuth } from 'contexts/auth';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/AccountSettings/desktop';
import Mobile from 'pages/AccountSettings/mobile';
import Tablet from 'pages/AccountSettings/tablet';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

const PageLayout = ({ location }) => {
    const { currentUser } = useAuth();
    const history = useHistory();
    const { device } = useViewport();
    const [incomingToken, setIncomingToken] = useState(null);

    useEffect(() => {
        const { token } = queryString.parse(location.search);
        if (token) setIncomingToken(token);
        if (currentUser?.profile_set_up) return history.push('/');
    }, [location.search, currentUser?.profile_set_up, history]);

    const props = { incomingToken };

    const renderResponsiveLayouts = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return renderResponsiveLayouts(device);
};

export default PageLayout;
